import React, {useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {useHistory} from 'react-router-dom';
import { Card, PageTitle } from '../../../styles';
import { Button } from '@material-ui/core';
import Table from '../../../components/Table/Table';
import LoadMoreButton from '../../../components/LoadMoreButton';
import { EmptyState } from '../../../components/EmptyState/EmptyState';
import { ReactComponent as EmptyStateImg } from '../../../assets/empty-state-search.svg';
import Box from '../../../components/_styles/Box';
import {getCohorts, deleteCohort, setDimensionsToInitial, togglePatientCohort} from '../../../actions/radminUploads';
import {HeaderContainer} from './ViewPatients';
import {TemplateButton} from '../Messages/SmsCreationDialog';
import {InfoButtonIcon} from '../FollowUpList/Icons';
import DoubleDataCell from '../PatientList/LastScanCell';
import { makeStyles } from '@material-ui/core/styles';
import RemoveConfirmation from './RemoveConfirmation';
import SearchField from '../SharedComponents/SearchField'
import { isEmpty } from 'lodash';
import styled from 'styled-components'
import { ReactComponent as SearchIconCustom } from "../../../assets/searchIconGrey.svg";

import { showAlert } from "../../../actions/radminUploads";
import { Col } from 'react-bootstrap';


const useStyles = makeStyles({
    label: {
        padding: "5px 0px",
        fontSize: "12px",
        fontWeight: "bold"
    },
    campaignButton: {
        backgroundColor: "#00AEEF",
        textTransform: 'none',
        width: '8rem',
        height:'38px',
        color:'#FFFFFF',
        border:'2px solid #00AEEF',
        '&:hover':{
            backgroundColor:'transparent',
            color:'#00AEEF'
        },
    },
})

const SearchFieldContainer = styled.div`
    display: flex;
    flex: auto;
    justify-content: right;
    height:38px;
    margin-right:17px;
`

const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 78px;
  height: 24px;
  padding: 0 12px;
  border-radius: 100px;
  color: #ffffff;
  font-size: 11px;
  font-weight: 600;
  font-family: Open Sans, sans-serif;
  background: ${({ active }) => (active ? "#64C67C" : "#A7A9AD")};
`;

const StyledButton = styled.button`
border: 2px solid ${({ active }) => (!active ? "#00AEEF" : "#B5B5B5")};
color: ${({ active }) => (!active ? "#00AEEF" : "#B5B5B5")};
background: ${({ active }) => (!active ? "#EFFBFF" : "#FFFFFF")};
min-width: 153px;
font-size: 14px;
font-weight: ${({ active }) => (!active ? 700 : 400)};
height: 26px;
cursor: pointer;
position: relative;

&:first-child {
  border-radius: 4px 0 0 4px;
  border-right: 1px solid #00AEEF;
}

&:last-child {
  border-radius: 0 4px 4px 0;
  border-left: 1px solid #00AEEF;
}
`;

const columns = [
    { key: 'cohort_title', name: 'Name', width: "20%" },
    // { key: 'count', name: 'Count', width: "15%" }, TODO: Use when count added from BE
    { key: 'description', name: 'Description', align:"left"},
    {
        key: "active",
        name: "Status",
        width: "12%",
        displayCell: (cellValue) => (
            <StatusBadge active={!!cellValue}>
                {cellValue ? "Active" : "Inactive"}
            </StatusBadge>
        ),
    },
];

function CohortList({ activeTab, titleForSearch, setTitleForSearch, page, setPage }) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const history = useHistory();
    
    const cohortsList = useSelector(state => state.radAdmin.cohorts?.data)
    const isLoading = useSelector(state => state.radAdmin.cohorts.isLoading)
    const totalItems = useSelector(state => state.radAdmin.cohorts.totalItems)

    const [removeDialogOpen, setRemoveDialogOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [isLoadingDeleteCohort, setIsLoadingDeleteCohort] = useState(false)
    // const [page, setPage] = useState(1);
    // const [titleForSearch, setTitleForSearch] = useState('')
    const permission = useSelector((state) => state.auth.user.permission_level);
    const rolePermissions = useSelector(
    (state) =>state.auth.user.permissions
    );
    const createPermission = rolePermissions?.find(itm=>itm.name ==="Cohorts")?.permissions.find(itm=>itm.codename === "add_cohorts")?.is_authorized

    useEffect(() => {
      if (activeTab === "patients") {
            const query = new URLSearchParams(history.location.search);
            let title = query.get('title')
            if(title){
                dispatch(getCohorts(page, title));
            }else{
                dispatch(getCohorts(page, titleForSearch));
            }
        dispatch(setDimensionsToInitial())
          }
    }, [])


    useEffect(() => {
      if (activeTab === "patients") {
        const query = new URLSearchParams(history.location.search);
        let title = query.get('title')
        if(title){
            setTitleForSearch(title)
            dispatch(getCohorts(null, title));
        }
      }
    }, [])

    const handleToggleChange = async (rowData, active) => {
      const success = await dispatch(
        togglePatientCohort(rowData.id, active)
      );
    
      if (success) {
        dispatch(getCohorts(page, titleForSearch));
      }
    };

    const viewPatientHandler = (data) => {
        window.analytics.track('Cohort-Patient-View-Button-Click');
        history.push({
            pathname: `/auth/radAdmin/followUp/patients/cohorts/details/${data.id}`,
            state: {data}
        })
    }

    const dialogHandler = (data) => {
        setRemoveDialogOpen(!removeDialogOpen);
        setSelectedId(data.id);
        window.analytics.track('Cohort-Delete-Button-Click');
    }

    const createCohortHandler = () => {
        if((permission && createPermission) || !permission){
            history.push('/auth/radAdmin/messages/cohorts/create');
            window.analytics.track('Cohort-Create-Button-Click');
          }else{
            dispatch(
              showAlert('danger', 'Error', `You don't have permission to create cohorts`)
            );
          }
    }

    const onLoadMore = () => {
        dispatch(getCohorts(page + 1, titleForSearch));
        setPage(page + 1)
    }

    const deleteCohortHandler = () => {
        setIsLoadingDeleteCohort(true)
        dispatch(deleteCohort(selectedId))
        .then(() => {
            setIsLoadingDeleteCohort(false)
            setRemoveDialogOpen(false);
        })
    }
    
    return (
        <Box>
            <RemoveConfirmation 
                content="Are you sure you want to remove this cohort?"
                openDialog={removeDialogOpen}
                dialogHandler={dialogHandler}
                isLoading={isLoadingDeleteCohort}
                deleteHandler={deleteCohortHandler}
                heading={'Remove Cohort'}
                removeHeader={'Yes, Remove Cohort'}
            />
            {/* <HeaderContainer>
            <PageTitle>Cohorts</PageTitle>
            <SearchFieldContainer>
            <SearchField 
                placeholder="Search Cohort Title"
                value={titleForSearch}
                onChangeHandle={(e) => {
                    setTitleForSearch(e.target.value)
                    history.push({
                        search: `?title=${e.target.value}`
                      })
                }}
                onReset={() => {
                    if(titleForSearch){
                        dispatch(getCohorts(1, ''))
                        setPage(1)
                        setTitleForSearch('')
                        history.push({
                            search: `?title=`
                          })
                    }
                }}
                onSearchEnter={() => {
                    setPage(1)
                    dispatch(getCohorts(null, titleForSearch))
                } 
            }
            styles={{
                marginRight: 0,
                marginBottom: 0,
                width: "318px",
                position: "relative",
              }}
              placeholderStyles={{
                color: "#828282",
                fontWeight: 400,
                fontSize: "16px",
                fontFamily: "Open Sans",
                marginLeft: "32px",
              }}
              inputStyles={{
                background: "#FFFFFF",
                border: "1px solid #D2D3D7",
                textAlign: "left",
                paddingLeft: "20px",
                height:'38px'
              }}
              searchIconStyles={{
                marginLeft: "12px",
              }}
              clearIconStyle={{
                right: 20,
                marginLeft: 0,
              }}
              SearchIconCustom={<SearchIconCustom />}
            />
            </SearchFieldContainer>
            
            <div>
            <Button
                classes={{ label: classes.label, root: classes.campaignButton }}
                onClick={createCohortHandler}
            >
                Create Cohort
            </Button>
            </div>
            </HeaderContainer> */}
            <div style={{width: '94.2vw'}}>
            <Card>
              <div style={{overflowX:'auto'}}>
                <Table
                    rows={cohortsList && cohortsList}
                    columns={columns.slice(0,3).concat(
                        { key: '1', name: '', displayCell: (cellValue, rowData) => <TemplateButton clickHandler={() => viewPatientHandler(rowData)} border={true} color={"#00AEEF"} outlinedBr={'#00AEEF'} title="View Patients" width icon={<InfoButtonIcon />}/>, width:"20px" },
                        {
                          key: "2",
                          name: "",
                          displayCell: (cellValue, rowData) => (
                            <Col>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <StyledButton
                                  active={rowData.active}
                                  onClick={() => handleToggleChange(rowData, false)}
                                >
                                  Disable
                                </StyledButton>
                        
                                <StyledButton
                                  active={!rowData.active}
                                  onClick={() => handleToggleChange(rowData, true)}
                                >
                                  Enable
                                </StyledButton>
                              </div>
                            </Col>
                          ),
                          width: "20px",
                        },
                        { 
                            key: '3',
                            name: '',
                            displayCell: (cellValue, rowData) =>  <DoubleDataCell mainInfo={'edit'}
                            EditRecoHandler={() =>{ 
                                if((permission && rolePermissions.find(itm=>itm.name ==="Cohorts")?.permissions.find(itm=>itm.codename === "change_cohorts")?.is_authorized) || !permission){
                                history.push('/auth/radAdmin/followUp/patients/cohorts/create', {data: rowData})
                                window.analytics.track('Cohort-Edit-Button-Click');
                                  }else{
                                    dispatch(
                                      showAlert('danger', 'Error', `You don't have permission to update cohort`)
                                    );
                                  }   
                            }}
                            RemoveRecoHandler={(() =>{
                                if((permission && rolePermissions.find(itm=>itm.name ==="Cohorts")?.permissions.find(itm=>itm.codename === "delete_cohorts")?.is_authorized) || !permission){
                                    dialogHandler(rowData)
                                  }else{
                                    dispatch(
                                      showAlert('danger', 'Error', `You don't have permission to delete cohort`)
                                    );
                                  }
                            } 
                           )}/>,
                            width:"20px"
                        }
                    )}
                    isLoadingRows={isLoading && (cohortsList.length === 0 || cohortsList.length === 1)}
                    getRowsAction={(pageNumber) => getCohorts(pageNumber, titleForSearch)}
                    noDataRender={() => (
                        <EmptyState title={'No Results'} img={() => <EmptyStateImg />}>
                          Sorry, there are no results
                        </EmptyState>
                      )}
                />
                 {cohortsList && cohortsList.length !== 0 && (
                    <LoadMoreButton
                        title="Load more"
                        isLoading={isLoading && totalItems !== cohortsList.length}
                        handleClick={onLoadMore}
                        isDisabled={totalItems === cohortsList.length}
                    />
                 )} 
                 </div>
            </Card>
            </div>
        </Box>
    )
}

export default CohortList
